const API_URL = process.env.NEXT_PUBLIC_SERVER_BASE_URL
export const isClient = typeof window !== "undefined"
export const isDev = API_URL?.includes("dev")
export const isMain = !isDev
